import {SwaggerRepository} from "@/apps/identity-api/api/swagger";

export default {
    swagger: new SwaggerRepository(),
}